import PropTypes from 'prop-types';
import { Button } from '@edx/paragon';

import cn from 'classnames';
import AiIcon from '../assets/ai/AiIcon';
import CloseIcon from '../assets/ai/CloseIcon';
import ExpandIcon from '../assets/ai/ExpandIcon';
import CollapseIcon from '../assets/ai/CollapseIcon';

const AiHeader = ({
  className,
  mobile,
  handleClose,
  isExpanded,
  toggleExpand,
  handleTutorClose,
}) => (
  <div
    className={cn(
      `tw-flex tw-justify-between tw-gap-7 tw-bg-mainOrange tw-px-[10px] tw-py-3 ${className}`,
      { 'tw-rounded-t-md': !mobile }, // NOTE: Used cn library to conditionally apply classes cuz md: has different size between paragon breakpoints
    )}
  >
    <div className="tg-gap-1 tw-flex tw-items-center">
      <AiIcon width={56} height={56} />

      <div className="tw-flex tw-flex-col tw-justify-center">
        <h6 className="tw-text-base tw-font-medium tw-text-white">AI Tutor</h6>
        <p className="tw-text-xs tw-text-white md:tw-font-medium">
          ШІ помічник за матеріалами курсу
        </p>
      </div>
    </div>

    {!mobile && (
      <>
        <div className="tw-mr-[6px] tw-flex tw-gap-6">
          <button
            type="button"
            onClick={toggleExpand}
            className={`${!isExpanded && 'tw-mb-[10px]'}`}
            title={isExpanded ? 'Згорнути' : 'Розгорнути'}
          >
            {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
          </button>

          {isExpanded && (
            <button type="button" onClick={handleTutorClose} title="Закрити">
              <CloseIcon />
            </button>
          )}
        </div>
      </>
    )}

    {mobile && (
      <Button
        variant="brand"
        className="tw-h-12 tw-w-12 tw-self-center tw-rounded-full !tw-p-2"
        onClick={handleClose}
        title="Закрити ШІ помічник"
      >
        <CloseIcon />
      </Button>
    )}
  </div>
);

AiHeader.propTypes = {
  className: PropTypes.string,
  mobile: PropTypes.bool,
  handleClose: PropTypes.func,
  isExpanded: PropTypes.bool,
  toggleExpand: PropTypes.func,
  handleTutorClose: PropTypes.func,
};

AiHeader.defaultProps = {
  className: '',
  mobile: false,
  handleClose: () => {},
  isExpanded: false,
  toggleExpand: () => {},
  handleTutorClose: () => {},
};

export default AiHeader;
